import React, { useEffect } from 'react'
import Header from '../Header/Main'
import Footer from '../Footer/Main'
import Aos from 'aos'

import About from '../Menabout/About'
import Whyus from '../Menabout/Whyus'
import Ourvalue from '../Menabout/Ourvalue'
import Textlist from '../Menhome/Textlist'
import Service from '../Menabout/Service'
import Testimonial from '../Menabout/Testimonial'
import Team from '../Menabout/Team'
import Faq from '../Menabout/Faq'
import App from '../Menabout/App'

import Contactblock from '../Mencontact/Contactblock'
import Contactform from '../Mencontact/Contactform'
import Map from '../Mencontact/Map'

import Banner from '../Menhome/Banner'
import UserBenefits from '../Menhome/UserBenefits'
import HowWork from '../Menhome/HowWork'
import Review from '../Menhome/Review'
import Clients from '../Menhome/Clients'
import Pricing from '../Menhome/Pricing'
import Interface from '../Menhome/Interface'
import Text from '../Menhome/Text'
import Blog from '../Menhome/Blog'

import heroBannerData from '../../data/heroBanner.json'

function Main() {

    useEffect(() => {
        Aos.init();
        Aos.refresh();
    }, []);

    return (
        <>
            <Header />
            <div className="page_wrapper">
            <About />
                <Whyus />
                <Ourvalue />
                <Textlist />
                <Service />
                <Testimonial />
                <Team />
                <Faq />
                <App />

                <Contactblock/>
                <Contactform/>
                <Map/>

                <Banner 
                typeAnimationDataPhrases={heroBannerData.sequence} 
                typeAnimationTypingSpeed={heroBannerData.typingSpeed}
                typeAnimationDeletionSpeed={heroBannerData.deletionSpeed}
                typeAnimationPauseTime={heroBannerData.pauseTime}
                />
                <UserBenefits />
                <div className='page_wrapper'>
                    <About />
                    <Textlist />
                    <Service />
                    <HowWork />
                </div>
                <Interface />

                <Footer />
            </div>
           
        </>
    )
}

export default Main